import React from 'react'
import _ from 'lodash'
import { FormattedMessage } from 'react-intl'

import apolloClient from '../services/ApolloClient'

export function getCurrentUserObjectFromToken(token) {
  try {
    let claims = JSON.parse(
      atob(
        token.split('.')[1]
      )
    )

    let user = {
      id: claims.sub,
      exp: claims.exp,
      username: claims.username,
      status: true,
      token
    }

    return user
  } catch (e) {
    return null
  }
}

export function makeTranslationAware(Component) {
  return ({ children, ...props }) => (
    <FormattedMessage
      id={ children }
    >
      {(text) => (
        <Component { ...props }>
          { text }
        </Component>
      )}
    </FormattedMessage>
  )
}

export function writeSinglePathOnCache(path, object) {
  let data = _.set({}, path, object)
  apolloClient.writeData({ data })
}



// WEBPACK FOOTER //
// ./src/utils/index.js